<!--
 * @Author: Gaho
 * @Date: 2024-01-15 10:16:16
 * @LastEditors: Gaho
 * @LastEditTime: 2024-12-26 11:35:41
-->
<template>
    <article>
        <section>
            <Button 
                @click="handleReducePercent"
                :disabled="isSubmiting"
                class="mr-2 min-w-[40px]"
            >
                -10%
            </Button>
            <Button 
                @click="handleReduce"
                :disabled="isSubmiting"
            >
                -1
            </Button>
            <input 
                type="number" 
                min="1.01" 
                max="9999" 
                step="0.01" 
                :value="targetValue"
                @input="handleInput"
                :readonly="isSubmiting"
                @blur="betNumOnblur"
            >
            <Button 
                @click="handleAdd" 
                :disabled="isSubmiting"
            >
                +1
            </Button>
            <Button 
                @click="handleAddPercent" 
                :disabled="isSubmiting"
                class="ml-2 min-w-[40px]"
            >
                +10%
            </Button>
        </section>
        <section class="target-text">
            {{ $t('target') }}
        </section>
    </article>
</template>
<script lang="ts">
export default {
    name: 'BetTargetOption'
}
</script>
<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from "vue-i18n";

import { accMultiple, accSub, accAdd } from "@/pages/casino/plinkoGame/js/module.js";
const props = defineProps({
    isSubmiting: {// 用於防止重複點擊,以及自動投注持續化條件
        type: Boolean,
        required: true
    },
    betTargetModelValue: { // target倍数
        type: Number,
        required: true
    }
})
const { t: $t } = useI18n()

const targetValue = ref(props.betTargetModelValue);

const emit = defineEmits([
    'update:betTargetModelValue'
]);

/**
 * emit target value
 * @param value target value
 */
const handleEmitBetTarget = (value: number) => {
    const regex = /^\d+(\.\d{0,2})?$/;
    let inputValue = String(value);
    if (!regex.test(inputValue)) {
        inputValue = Number(inputValue).toFixed(2); // 删除最后一个字符
    }
    targetValue.value = Number(inputValue)
    emit('update:betTargetModelValue', Number(inputValue));
}

/**
 * 减
 */
const handleReduce = () =>  {
    if (props.isSubmiting) return;
    let value = props.betTargetModelValue;
    value = Number(accSub(value, 1));
    if (value < 1.01) { 
        value = 1.01 
    }
    targetValue.value = value;
    handleEmitBetTarget(value)
}
/**
 * 加
 */
const handleAdd = () => {
    if (props.isSubmiting) return;
    let value = props.betTargetModelValue;
    value = accAdd(value, 1);
    if (value > 9999) { 
        value = 9999; 
    }
    targetValue.value = value;
    handleEmitBetTarget(value)
}
/**
 * 手动输入target
 * @param e event
 */
const handleInput = (e) => {
    if (props.isSubmiting) return;
    let value = e.target.value;
    targetValue.value = value;
    handleEmitBetTarget(value)
}
/**
 * input失去焦点
 */
const betNumOnblur = () => {
    if (targetValue.value < 1.01) { 
        targetValue.value = 1.01; 
        handleEmitBetTarget(targetValue.value)
    } else if (targetValue.value > 9999) { 
        targetValue.value = 9999; 
        handleEmitBetTarget(targetValue.value)
    } else {
        handleEmitBetTarget(targetValue.value)
    }
}
/**
 * -10%
 */
const handleReducePercent = () => {
    if (props.isSubmiting) return;
    let value = props.betTargetModelValue;
    value = Number(Number(accSub(value, accMultiple(value, 0.1))).toFixed(2));
    if (value < 1.01) { 
        value = 1.01;
    }
    targetValue.value = value;
    handleEmitBetTarget(value)
}
/**
 * +10%
 */
const handleAddPercent = () => {
    if (props.isSubmiting) return;
    let value = props.betTargetModelValue;
    value = Number(accAdd(value, accMultiple(value, 0.1)).toFixed(2));
    if (value > 9999) { 
        value = 9999; 
    }
    targetValue.value = value;
    handleEmitBetTarget(value)
}
</script>
<style lang="scss" scoped>
article {
    grid-column: 3;
    background: #161f2c;
    border: 1px solid #4b5b74;
    border-radius: 10px;
    padding: 8px;
    position: relative;
    .target-text {
        @media (max-width: 359px) { //兼容360及以上展示
            display: none !important;
        }
        @media (max-width: 370px) { //处理超出
            font-size: 12px !important;
        }
    }
    section {
        display: flex;
        justify-content: space-between;
        button {
            background-color: #283343;
            border: 1px solid transparent;
            border-radius: 7px;
            color: #55657e;
            font-size: 12px;
            font-weight: 600;
            height: 35px;
            line-height: 23px;
            margin-bottom: 5px;
            padding: 0;
            transition: all .3s;
            -webkit-user-select: none;
            -moz-user-select: none;
            user-select: none;
            width: 35px;
            &:hover {
                background: #122e4f;
                border: 1px solid #297fe5;
                color: #fff;
            }
            &:focus {
                background: #297fe5;
                color: #fff;
            }
        }
        @media (max-width: 768px) {
            button {
                margin-bottom:0
            }
        }

        input {
            background-color: transparent;
            border: none;
            color: #fff;
            font-size: 20px;
            font-weight: 700;
            outline: none;
            padding: 0;
            text-align: center;
            width: 100px;
            min-height: 30px;
        }

        @media (max-width: 768px) {
            input {
                min-width:100px;
            }
        }

        &:nth-of-type(2){
            color: #55657e;
            display: block;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            text-transform: uppercase;
        }
    }
}
@media (max-width: 768px) {
    article {
        grid-column:1/3;
        grid-row: 1;
        align-items: center;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
    }
}
</style>